module.exports = __webpack_public_path__ + "img/Q70A.85c28995.png";